import {
    ControlList,
    Dialog,
    useListGraphqlQuery,
    useUrlParamsValueToString,
} from "@bsm/component";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SIGNATORY_LIST_ID } from "../../../container/InvoiceListViewerSignatoriesContainer";
import { useInvoiceSignatoryCreateForm } from "../hooks/useInvoiceSignatoryCreateForm";
import { useInvoiceDetailsQuery } from "../../details/hooks/useInvoiceDetailsQuery";

export default function SignatoryCreateContainer() {
    const { id } = useParams();
    const navigate = useNavigate();
    const urlParams = useUrlParamsValueToString();
    const { invalidateQuery } = useListGraphqlQuery(SIGNATORY_LIST_ID);
    const { invalidateQuery: invalidateDetailsQuery } = useInvoiceDetailsQuery(id ? parseInt(id) : undefined);
    const control = useInvoiceSignatoryCreateForm(id ? parseInt(id) : undefined);

    const handleSubmited = useCallback(() => {
        invalidateQuery();
        invalidateDetailsQuery();
        navigate(`..?${urlParams}`);
    }, [invalidateQuery]);

    const handleClose = useCallback(() => {
        navigate(`..?${urlParams}`);
    }, []);

    return (
        <Dialog open title={id ? "Edit Signatory" : "Add New Signatory"} onClose={handleClose}>
            <ControlList
                {...control}
                defaultValue={{
                    id: id ? parseInt(id) : undefined,
                }}
                onCancel={handleClose}
                onSubmited={handleSubmited}
            />
        </Dialog>
    );
}
